// extracted by mini-css-extract-plugin
export default {"productOffer":"product-offers-modal__productOffer__gXbzg","disclaimer":"product-offers-modal__disclaimer__ro3hJ","productOfferLink":"product-offers-modal__productOfferLink__mWzgs"};